import i18next from "i18next";
import { ReportEntry } from "../@types/ReportEntry";

export enum Status {
  APPROVED = "APPROVED",
  FINANCIAL_VALIDATION = "FINANCIAL_VALIDATION",
  ON_APPROVAL = "ON_APPROVAL",
  REFUSED = "REFUSED",
  PAID = "PAID",
  FINISHED = "FINISHED",
}

export const statusToString = (data: ReportEntry) => {
  switch (data.reportEntryStatus) {
    case Status.REFUSED:
      return data.refusedByOwner? i18next.t(`status.REFUSED_FINANCIAL`)
      : data.approvedByFinancial? i18next.t(`status.REFUSED_OWNER`): i18next.t(`status.REFUSED`);
    case Status.ON_APPROVAL:
      return data.approvedByOwner? i18next.t(`status.ON_APPROVAL_PENDING_FINANCIAL`)
      : data.approvedByFinancial? i18next.t(`status.ON_APPROVAL_PENDING_OWNER`): i18next.t(`status.ON_APPROVAL`);
    default:
      return i18next.t(`status.${data.reportEntryStatus}`);
  }
};

export const statusTextColor = (status: Status) => {
  switch (status) {
    case Status.APPROVED:
      return "#000000";
    case Status.ON_APPROVAL:
      return "#624C00";
    case Status.FINANCIAL_VALIDATION:
      return "#01733C";
    case Status.REFUSED:
      return "#B81010";
    case Status.PAID:
      return "#00373E";
    case Status.FINISHED:
      return "#0F5132";
    default:
      return "";
  }
};


export const statusBackgroundColor = (status: string) => {

  switch (status) {
    case Status.APPROVED:
      return "#99FFCE";
    case Status.ON_APPROVAL:
      return "#FFF2C3";
    case Status.FINANCIAL_VALIDATION:
      return "#99FFCE";
    case Status.REFUSED:
      return "#FFCCCC";
    case Status.PAID:
      return "#9EC9C9";
    case Status.FINISHED:
      return "#D1E7DD";
    default:
      return "";
  }
};


